import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Loading,
} from '@iguanads/react'
import { useTranslation } from 'react-i18next'

interface Props {
  open: boolean
  orderNumber: string
  customerName: string
  isLoading?: boolean
  onNotReady: () => void
  onReady: () => void
}

function PickupOrderReadyDialog({
  open,
  orderNumber,
  customerName,
  isLoading = false,
  onNotReady,
  onReady,
}: Props) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={() => undefined}>
      <DialogContent
        hideCloseButton
        className="max-w-lg gap-0"
        onPointerDownOutside={(event: Event) => event.preventDefault()}
        onInteractOutside={(event: Event) => event.preventDefault()}
        onEscapeKeyDown={(event: KeyboardEvent) => event.preventDefault()}
      >
        <DialogHeader className="px-6 pt-6">
          <DialogTitle className="text-primary text-center text-lg font-bold">
            {t('dialogs.pickupOrderReminders.ready.title', {
              orderNumber,
              customerName,
            })}
          </DialogTitle>
        </DialogHeader>

        <div className="p-6">
          <Card>
            <CardContent className="p-4">
              <p className="text-grayscale-darkest text-sm">
                {t('dialogs.pickupOrderReminders.ready.description')}
              </p>
            </CardContent>
          </Card>
        </div>

        <DialogFooter className="w-full justify-between px-6 pb-6">
          <Button
            type="button"
            variant="secondary"
            disabled={isLoading}
            onClick={onNotReady}
          >
            {t('dialogs.pickupOrderReminders.ready.notReady')}
          </Button>
          <Button type="button" disabled={isLoading} onClick={onReady}>
            {isLoading && <Loading size={2} color="white" className="mr-1" />}
            {t('dialogs.pickupOrderReminders.ready.orderReady')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export { PickupOrderReadyDialog }
